module.exports = __webpack_public_path__ + "img/scads_color.5ff0c1b2.svg";